import { useState } from "react";
import axiosInstance from "../../config/axiosConfig";
import { formatDate, formatMoney } from "../../utils/utils";
import MonthInput from "./MonthInput";

const Egresos = () => {
  const [showModal, setShowModal] = useState(false);
  const [periodo, setPeriodo] = useState(new Date().toISOString().slice(0, 7)); // Mes actual
  const [filteredEgresos, setFilteredEgresos] = useState([]);
  const [egresos, setEgresos] = useState();

  
  const filtrarEgresos = async () => {
    try {
      // Llamada a la API para obtener los movimientos por periodo
      const response = await axiosInstance.post("/financiero/cartola/egresos", { periodo });

      const movimientosFiltrados = response.data.data;
      setEgresos(movimientosFiltrados);
      setFilteredEgresos(movimientosFiltrados);

    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    }
  };

  // Calcular total de egresos filtrados
  const totalEgresos = filteredEgresos.reduce((acc, egreso) => acc + parseInt(egreso.monto), 0);

  return (
    <div className="container mt-4">
      <div className="card p-4 shadow">
        {/* Encabezado */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3>Egresos</h3>
        </div>

        {/* Filtros */}
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Período:</label>
            <MonthInput
              className="form-control"
              value={periodo}
              onChange={(e) => setPeriodo(e.target.value)}
            />
          </div>
          <div className="col-md-2 d-flex align-items-end">
            <button className="btn btn-primary" onClick={filtrarEgresos}>
              Buscar
            </button>
          </div>
        </div>

        {/* Indicador de Total de Egresos */}
        <div className="alert alert-info">
          <strong>Total de Egresos:</strong> ${formatMoney(totalEgresos)}
        </div>

        {/* Tabla de Egresos */}
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Título</th>
              <th>Monto</th>
              <th>Comentario</th>
            </tr>
          </thead>
          <tbody>
            {filteredEgresos.length > 0 ? (
              filteredEgresos.map((egreso) => (
                <tr key={egreso.id_movimiento}>
                  <td>{formatDate(egreso.fecha)}</td>
                  <td>{egreso.detalle}</td>
                  <td>${formatMoney(egreso.monto)}</td>
                  <td>{egreso.observacion}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="text-center text-muted">
                  No hay egresos para este período.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Fondo Oscuro para Modal */}
      {showModal && <div className="modal-backdrop fade show" onClick={() => setShowModal(false)}></div>}
    </div>
  );
};

export default Egresos;
